import { Auth } from "aws-amplify";

const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const protocol = isLocalhost ? 'http://' : 'https://';
const hostname = window.location.hostname;
const port = isLocalhost ? ':3000' : '';
const appEnvironment = process.env.REACT_APP_ENV || 'live';
const isStagingEnvironment = appEnvironment === 'staging';
const isDevEnvironment = appEnvironment === 'dev';

const developmentBackendUrl = process.env.REACT_APP_DEVELOPMENT_BACKEND_URL || '';
const stagingBackendUrl = process.env.REACT_APP_STAGING_BACKEND_URL || '';
const prodV1BackendUrl = process.env.REACT_APP_PROD_V1_BACKEND_URL || '';

const useDevelopmentBackendInProductionBuild =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_USE_DEVELOPMENT_BACKEND === 'true' &&
  developmentBackendUrl.trim() !== '';

const useStagingBackendInProductionBuild =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_USE_STAGING_BACKEND === 'true' &&
  stagingBackendUrl.trim() !== '';

const useProdV1BackendInProductionBuild =
  process.env.NODE_ENV === 'production' &&
  process.env.REACT_APP_BUILD_USE_PROD_V1_BACKEND === 'true' &&
  prodV1BackendUrl.trim() !== '';

const buildTimeApiEndpoint =
  prodV1BackendUrl || stagingBackendUrl || developmentBackendUrl;

const backendEndpoint = useDevelopmentBackendInProductionBuild
  ? developmentBackendUrl
  : (useStagingBackendInProductionBuild
    ? stagingBackendUrl
    : (useProdV1BackendInProductionBuild
      ? prodV1BackendUrl
      : (isDevEnvironment
        ? developmentBackendUrl
        : (isStagingEnvironment
          ? stagingBackendUrl
          : prodV1BackendUrl))));

if (useDevelopmentBackendInProductionBuild) {
  console.info('Using REACT_APP_DEVELOPMENT_BACKEND_URL (npm run build:dev):', backendEndpoint);
} else if (useStagingBackendInProductionBuild) {
  console.info('Using REACT_APP_STAGING_BACKEND_URL (npm run build:staging):', backendEndpoint);
} else if (useProdV1BackendInProductionBuild) {
  console.info('Using REACT_APP_PROD_V1_BACKEND_URL (npm run build:prod):', backendEndpoint);
} else if (isDevEnvironment) {
  console.info('Using REACT_APP_DEVELOPMENT_BACKEND_URL (npm run start:dev):', backendEndpoint);
} else if (isStagingEnvironment) {
  console.info('Using REACT_APP_STAGING_BACKEND_URL (npm run start:staging):', backendEndpoint);
} else {
  console.info('Using REACT_APP_PROD_V1_BACKEND_URL (npm run start:prod):', backendEndpoint);
}

const awsConfig = {

  //  us-east-1:66a2b483-d23f-4b59-bac1-cdf2dd3fcc66
  region: process.env.REACT_APP_AWS_REGION,
  userPoolId: process.env.REACT_APP_PRNTYR_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_PRNTYR_USER_POOL_CLIENT_ID,
  oauth: {
    domain: "prntyrapp.auth.us-east-1.amazoncognito.com",
    redirectSignIn: `${protocol}${hostname}${port}/redirect`,
    redirectSignOut: `${protocol}${hostname}${port}`,
    responseType: 'code'
  },

  API: {
    endpoints: [
      {
        name: 'Newsletter-bgndbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'slideapp-bgndbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'calendar-bgndbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'calendarapp-premade-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'slideapp-premade-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'calendarapp-custom-bgnbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'newsletterapp-custom-bgnbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'slideapp-custom-bgnbd-images',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },

      {
        name: 'Calendarapp-user-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'Newsletterapp-user-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },

      {
        name: 'Slideapp-user-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'Community-Content-Templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'SlideApp-signage-data',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'PDF-data',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },

      {
        name: 'Creaters-Content-Templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'Content-Template-file',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'ChatGpt-Content-Generation',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'Connect-ChatGpt',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'ChatGpt-Template',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'Creators-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'quick-prints',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'custom-fonts',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
       {
        name: 'service-templates',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'profile',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: 'assets',
        endpoint: buildTimeApiEndpoint,
        region: 'us-east-1',
        custom_header: async () => {
          return {
            Authorization: `${(await Auth.currentAuthenticatedUser()).signInUserSession.idToken.jwtToken}`
          }

        }
      },
      {
        name: "lambda",
        endpoint: "https://atqxeqncag.execute-api.us-east-1.amazonaws.com/alexa-speak2-live",
        region: 'us-east-1',
      }
    ]
  }
};

const prntyrApiBuildTimeUrls = [
  process.env.REACT_APP_DEVELOPMENT_BACKEND_URL,
  process.env.REACT_APP_STAGING_BACKEND_URL,
  process.env.REACT_APP_PROD_V1_BACKEND_URL,
].filter(Boolean);

awsConfig.API.endpoints = awsConfig.API.endpoints.map((endpointConfig) => {
  if (prntyrApiBuildTimeUrls.includes(endpointConfig.endpoint)) {
    return { ...endpointConfig, endpoint: backendEndpoint };
  }

  return endpointConfig;
});

export default awsConfig;